import r from "./ascending.js";
import t from "./bisector.js";
import e from "./number.js";
const i = t(r), s = i.right;
t(e).center;
export {
  s as bisectRight,
  s as default
};
